import React from "react";
import { SvgIcon } from "@mui/material";
import type { SvgIconProps } from "@mui/material";

// forwardRef so MUI Tooltip can anchor to the rendered <svg>.
const ReassignIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M12 2.7A9.3 9.3 0 1 1 2.84 10.39L5.2 10.8A6.9 6.9 0 1 0 12 5.1Z" />
    <path d="M12.2 0.9L6.2 4.05l6 3.15z" />
    <g transform="translate(12 12.2) scale(0.54) translate(-12 -12)">
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </g>
  </SvgIcon>
));

ReassignIcon.displayName = "ReassignIcon";

export default ReassignIcon;
